export const SITE_API_URI = environmentSettings.apiUrl;
export const SERVER_ID_MAX_LENGTH = 25;
export const SERVER_DESCRIPTION_MAX_LENGTH = 100;
export const PO_NUMBER_MAX_LENGTH = 10;
export const ABB_COMPANY_NAME = 'ABB';
export const SERVER_ID_FIELD_MAX_LENGTH = 4;
export const SITE_LIST_SEARCH_PLACEHOLDER = 'Search by Site, ServIS ID, Customer, and Region';
export const SERVIS_SEARCH_PLACEHOLDER = 'Search by Site and ServIS ID';
export const INVALID_SERVICE_VALUE = -1;

export const AVAILABLE_OPERATIONAL_USAGES = [
    {
        id: 1,
        usageName: 'Customer',
        label: 'Customer'
    },
    {
        id: 2,
        usageName: 'Demo',
        label: 'Demo'
    },
    {
        id: 3,
        usageName: 'Trial',
        label: 'Trial'
    }
];

export const API_ERROR_MESSAGE = 'Something went wrong and your updates could not be completed.  Try again or contact Customer Support at ';
export const API_SUPPORT_EMAIL = 'us-iasvsupport@abb.com';
export const API_SUPPORT_MAILTO = 'mailto:us-iasvsupport@abb.com';

export function isValidInput(text: string, maxLength: number) {
    const alphaNumericWithDash = new RegExp(/^[a-z0-9- ]+$/i);
    const moreThanWhitespace = new RegExp(/\S/);
    return text.length > 0 && text.length <= maxLength && alphaNumericWithDash.test(text) && moreThanWhitespace.test(text);
}

export function isValidServerNameInput(text: string, maxLength: number) {
    const alphaNumericWithDashEtc = new RegExp(/^[a-z0-9-_() ]+$/i);
    const moreThanWhitespace = new RegExp(/\S/);
    return text.length > 0 && text.length <= maxLength && alphaNumericWithDashEtc.test(text) && moreThanWhitespace.test(text);
}

export function isValidHardwareIdInput(text: string, maxLength: number) {
    const hardwareIdFormat = new RegExp(/^(?:[A-Za-z0-9]{4}-){3}[A-Za-z0-9]{4}$/g);
    const moreThanWhitespace = new RegExp(/\S/);
    return text.length > 0 && text.length <= maxLength && hardwareIdFormat.test(text) && moreThanWhitespace.test(text);
}

export function handleErrors(response: any) {
    if (!response.ok) {
        throw Error(response.statusText);
    }
    return response.json();
}



// WEBPACK FOOTER //
// ./~/tslint-loader??ref--0!./src/services/constants.ts